/* eslint-disable no-unused-vars */
import { useCallback, useMemo, useRef, useEffect } from 'react';
import { Buttons } from 'components';
import { AppsBudget } from 'assets/icons';
import * as S from './AppsMonthlyBudgets.styled';
import { useComputed, useSignal, useSignalEffect } from '@preact/signals-react';
import { ChooseAppsMonthlyBudgets } from 'components';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { monthlyBudgetAPI } from 'services/monthlyBudget.service';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { compareDateObjects, showPolipop, useLockBodyScroll } from 'utils';

const doRequest = (data, dateForRequest, newDateForRequest) => {
  if (!data) return true;
  if (!compareDateObjects(newDateForRequest.current, dateForRequest)) return true;
  return false;
};

export const AppsMonthlyBudgets = () => {
  const isOpenModal$ = useSignal(false);
  useLockBodyScroll(isOpenModal$.value);
  const dateForRequest = useSelector(
    (state) => state.manageCampaigns.selectedDateRange,
    compareDateObjects,
  );
  const newDateForRequest = useRef(dateForRequest);
  const { data: appsBudgetCounter } = manageCampaignsAPI.useGetAppsBudgetCounterQuery(
    dateForRequest,
    {
      skip: Object.keys(dateForRequest).length === 0,
    },
  );

  // const [action, result] = manageCampaignsAPI.useLazyGetMonthlyBudgetAppsQuery();
  // const [saveApps, saveResult] = manageCampaignsAPI.useSaveMonthlyBudgetAppsMutation();
  const [action, result] = monthlyBudgetAPI.useLazyGetMonthlyBudgetAppsQuery();
  const [saveApps, saveResult] = monthlyBudgetAPI.useSaveMonthlyBudgetAppsMutation();

  const isAppBudgetCounter = useMemo(() => {
    return appsBudgetCounter?.counter > 0;
  }, [appsBudgetCounter?.counter]);

  const handleClick = useCallback(() => {
    isOpenModal$.value = !isOpenModal$.value;
  }, []);

  // Deep-link from the dashboard setup checklist: open the modal once, then clear the
  // navigation state so a refresh or back-navigation doesn't reopen it.
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!location.state?.openAppsBudgets) return;
    isOpenModal$.value = true;
    navigate(location.pathname + location.search, { replace: true, state: null });
  }, []);

  useEffect(() => {
    if (saveResult.status !== 'uninitialized') {
      showPolipop(saveResult);
    }
  }, [saveResult]);

  useSignalEffect(() => {
    if (!isOpenModal$.value) return;
    if (doRequest(result.data, dateForRequest, newDateForRequest)) {
      action(dateForRequest);
      newDateForRequest.current = dateForRequest;
    }
  });
  const resultFromRequest$ = useSignal(result);

  useEffect(() => {
    resultFromRequest$.value = result;
  }, [result]);

  return (
    <div>
      <S.ContainerBtn>
        <Buttons.TertiaryNormal
          icon={<AppsBudget />}
          id='appsMonthlyBudgets'
          isDisabled={saveResult.isLoading}
          onClick={handleClick}
        >
          Apps Budgets
          {isAppBudgetCounter ? <S.Alert>{appsBudgetCounter?.counter}</S.Alert> : null}
        </Buttons.TertiaryNormal>
      </S.ContainerBtn>
      {useComputed(() =>
        isOpenModal$.value ? (
          <ChooseAppsMonthlyBudgets
            isOpen$={isOpenModal$}
            result={resultFromRequest$.value}
            saveAction={saveApps}
            saveResult={saveResult}
          />
        ) : null,
      )}
    </div>
  );
};
